export default __webpack_public_path__ + "media/10-second-count-down-104235.ad2ca985.mp3";